import React, { useCallback } from 'react'
import { Icon, l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

import cm from './styles.module.css'

interface EmptyStateProps {
  disabled?: boolean
}

export const EmptyState = ({ disabled }: EmptyStateProps) => {
  const dispatch = useAppDispatch()

  const handleClick = useCallback(
    (goal: GoalType) => {
      dispatch(
        AiAutomationLayoutActions.sidebarOpened({
          view: SidebarViewType.ENGAGEMENT_GOAL_EDITOR,
          payload: { goalType: goal },
        }),
      )
    },
    [dispatch],
  )

  return (
    <div className={cm.wrapper}>
      <ul className={cm.goalsList}>
        <li>
          <button
            onClick={() => handleClick(GoalType.LEAD_GEN)}
            className={cm.goalOption}
            disabled={disabled}
          >
            <Icon.Link size={20} />

            <span>
              <span className={cm.goalOption__title}>{l.translate('Share a link')}</span>

              <span className="text-body-sm text-secondary">
                {l.translate('Get your content seen')}
              </span>
            </span>
          </button>
        </li>

        <li>
          <button
            onClick={() => handleClick(GoalType.GROW_FOLLOWERS)}
            className={cm.goalOption}
            disabled={disabled}
          >
            <Icon.Community size={20} />

            <span>
              <span className={cm.goalOption__title}>{l.translate('Grow followers')}</span>

              <span className="text-body-sm text-secondary">
                {l.translate('Ask newcomers to follow')}
              </span>
            </span>
          </button>
        </li>

        <li>
          <button
            onClick={() => handleClick(GoalType.LEAD_QUAL)}
            className={cm.goalOption}
            disabled={disabled}
          >
            <Icon.PublicChangelog size={20} />

            <span>
              <span className={cm.goalOption__title}>{l.translate('Capture leads')}</span>

              <span className="text-body-sm text-secondary">
                {l.translate('Collects numbers or emails')}
              </span>
            </span>
          </button>
        </li>
      </ul>
    </div>
  )
}
